import React, { useEffect } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import CardUser from './CardUser'
import { getAllusers } from '../Redux/Actions/AuthActions'



const ListUser = () => {
  const dispatch = useDispatch()
    useEffect(()=>{
        dispatch(getAllusers())
    },[])

    const users = useSelector(state => state.AuthReducer.users || [])

    return(
        <div className="row" style={{ marginTop: '100px', padding: '20px' }}>
            {
                users.map((el,i,t)=> (<div key={el._id || el.id} className="col-lg-2 col-md-4 col-sm-5  mb-4">
                    <CardUser el={el} />
                  </div>))
            }
        </div>
    )
}

export default ListUser
